webpackJsonp([1],{

/***/ "./node_modules/nucleus-widgets/lib/EmptyCell/EmptyCell.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _nucleusDynamicCss = __webpack_require__("./node_modules/@cvent/nucleus-dynamic-css/lib/es/index.js");

var _nucleusTestAutomation = __webpack_require__("./node_modules/@cvent/nucleus-test-automation/lib/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

/**
* An empty widget that is used to populate a layout column that contains no other widget content.
* Can also be left in the layout to create empty space if needed.
*/
var EmptyCell = function (_React$Component) {
  _inherits(EmptyCell, _React$Component);

  function EmptyCell() {
    _classCallCheck(this, EmptyCell);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  EmptyCell.prototype.render = function render() {
    return _react2.default.createElement('div', _extends({}, (0, _nucleusTestAutomation.resolveTestId)(this.props), (0, _nucleusDynamicCss.resolve)(this.props, 'container')));
  };

  return EmptyCell;
}(_react2.default.Component);

EmptyCell.displayName = 'EmptyCell';
exports.default = EmptyCell;

/***/ }),

/***/ "./node_modules/nucleus-widgets/lib/EmptyCell/EmptyCell.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"EmptyCell__container___NlLF0"};

/***/ }),

/***/ "./node_modules/nucleus-widgets/lib/EmptyCell/EmptyCellWidget.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BaseWidget2 = __webpack_require__("./node_modules/nucleus-widgets/lib/BaseWidget.js");

var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);

var _EmptyCell = __webpack_require__("./node_modules/nucleus-widgets/lib/EmptyCell/EmptyCell.js");

var _EmptyCell2 = _interopRequireDefault(_EmptyCell);

var _EmptyCell3 = __webpack_require__("./node_modules/nucleus-widgets/lib/EmptyCell/EmptyCell.less");

var _EmptyCell4 = _interopRequireDefault(_EmptyCell3);

var _nucleusTestAutomation = __webpack_require__("./node_modules/@cvent/nucleus-test-automation/lib/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

/**
* Data wrapper for the empty cell widget.
*/
var EmptyCellWidget = function (_BaseWidget) {
  _inherits(EmptyCellWidget, _BaseWidget);

  function EmptyCellWidget() {
    _classCallCheck(this, EmptyCellWidget);

    return _possibleConstructorReturn(this, _BaseWidget.apply(this, arguments));
  }

  EmptyCellWidget.prototype.render = function render() {
    var _props = this.props,
        classes = _props.classes,
        style = _props.style;

    return _react2.default.createElement(_EmptyCell2.default, _extends({}, (0, _nucleusTestAutomation.resolveTestId)(this.props), {
      classes: classes,
      style: this.getStyleObject(style) }));
  };

  return EmptyCellWidget;
}(_BaseWidget3.default);

EmptyCellWidget.displayName = 'EmptyCellWidget';
EmptyCellWidget.propTypes = {
  type: _propTypes2.default.string,
  config: _propTypes2.default.object,
  classes: _propTypes2.default.object,
  style: _propTypes2.default.object
};
EmptyCellWidget.defaultProps = {
  classes: _EmptyCell4.default
};
exports.default = EmptyCellWidget;

/***/ })

});


// WEBPACK FOOTER //
// 1.prod._v4.be1885a49d3bb7729a13.js